<form [formGroup]="form" (ngSubmit)="generateFragmentos()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Compartir Llave Privada</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="form-group col-md-12">
                <label for="longitud">Longitud</label>
                <input type="text" readonly="true" class="form-control" id="longitud" formControlName="longitud"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.longitud.errors }">
                <div *ngIf="submitted && form.controls.longitud.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.longitud.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="llavePrivada">Llave Privada</label>
                <textarea #llavePrivada rows="5" readonly="true" class="form-control" id="llavePrivada"
                    appBlockCopyPaste formControlName="llavePrivada"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.llavePrivada.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.llavePrivada.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.llavePrivada.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label for="fragmentos">Fragmentos</label>
                <input type="number" class="form-control" id="fragmentos" formControlName="fragmentos"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.fragmentos.errors }">
                <div *ngIf="submitted && form.controls.fragmentos.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.fragmentos.errors.required">Campo requerido</div>
                    <div *ngIf="form.controls.fragmentos.errors.min">La cantidad mínima de fragmentos es de 2</div>
                    <div *ngIf="form.controls.fragmentos.errors.max">La cantidad máxima de fragmentos es de 4</div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <div class="col-md-12 text-center">
                    <button type="submit" class="btn btn-info col-md-4">
                        <i class="fa fa-key"></i>
                        Generar Fragmentos
                    </button>
                </div>
            </div>

            <div class="card-body table-responsive table-hover p-0"
                style="height: auto; max-height: 600px;">
                <table class="table table-bordered table-head-fixed">
                    <thead>
                        <tr>
                            <th scope="col">Fragmento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of listaFragmentos">
                            <td>{{item}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="form-group col-md-12 fix-margin-top-table">
                <div class="col-md-12 text-center">
                    <button type="button" class="btn btn-info btn-fidelis col-md-4" (click)="downloadFragmentos()">
                        <i class="fa fa-download"></i>
                        Descargar Fragmentos
                    </button>
                </div>
            </div>
        </div>

        <div class="modal-footer full-width col-md-12">
            <div class="col-md-12 text-center">
                <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                    <i class="fa fa-times-circle"></i>
                    Cancelar
                </button>
                <button type="button" class="btn btn-success btn-fidelis col-md-4" (click)="save()">
                    <i class="fa fa-check-circle"></i>
                    Guardar
                </button>
            </div>
        </div>

    </div>
</form>